import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/autoplay';
if (customElements.get('component-marks-carousels') === undefined) {
    class Marks extends HTMLElement {
        constructor() {
            super();
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.querySelectorAll('.mark-carousel').forEach((carousel, idx) => this.setCarousel(carousel, idx));
        }
        setCarousel(carousel, idx) {
            // Configuración por defecto
            const config = {
                spaceBetween: 30,
                freeMode: true,
                grabCursor: true,
                slidesPerView: 'auto',
                loop: true,
                loopAddBlankSlides: true,
                loopAdditionalSlides: 20,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true,
                    reverseDirection: idx == 1 ? true : false
                },
                speed: 8000,
                freeModeMomentum: false,
                modules: [Autoplay],
            };
            new Swiper(carousel, config);
        }
    }
    customElements.define('component-marks-carousels', Marks);
}
